import { DateHelper } from "@bryntum/schedulerpro";
import { useFileDetailModal } from "../context/FileDetailModalContext";
import { FileDescriptionSection } from "./FileDescriptionSection";
import { FileAccessSection } from "./FileAccessSection";
import { getAging, getFormattedFileSize } from "@/other/utils/utils";
import { cn } from "@/modern/utils";

interface FileDetailsSectionProps {
  className?: string;
}

/**
 * Metadata + unified form (description, can edit, can view).
 */
export function FileDetailsSection({ className }: FileDetailsSectionProps) {
  const { file, project } = useFileDetailModal();

  if (!file) return null;

  const uploadedDate = file.createdAt ? DateHelper.format(new Date(file.createdAt), "MM/DD/YYYY") : "";
  const sourceLabel = file.source === "companycam" ? "CompanyCam" : "Swivu";
  const ageDays = file.createdAt ? getAging(file.createdAt) : null;
  const size = file.sizeBytes ? getFormattedFileSize(file.sizeBytes) : undefined;
  const addedBy = file.creator ? project?.boardUsersStore?.getById(file.creator)?.name : undefined;

  const rows: { label: string; value: string }[] = [
    { label: "File", value: file.name },
    { label: "Source", value: sourceLabel },
  ];
  if (size && size !== "N/A") {
    rows.push({ label: "Size", value: String(size) });
  }
  if (ageDays) {
    rows.push({ label: "Age", value: String(ageDays) });
  }
  if (uploadedDate) {
    rows.push({
      label: "Uploaded",
      value: addedBy ? `${uploadedDate} · ${addedBy}` : uploadedDate,
    });
  }

  return (
    <div className={cn("space-y-4", className)}>
      <dl className="space-y-3">
        {rows.map((row) => (
          <div key={row.label}>
            <dt className="text-xs font-normal uppercase tracking-wide text-muted-foreground">
              {row.label}
            </dt>
            <dd className="mt-0.5 break-all text-base font-normal leading-snug text-foreground">
              {row.value}
            </dd>
          </div>
        ))}
      </dl>

      <div className="space-y-4 border-t border-border/40 pt-4">
        <FileDescriptionSection key={file.id} />
        <FileAccessSection />
      </div>
    </div>
  );
}
